import { Route } from '@angular/router';
import { CastPageComponent } from './pages/cast-page';

export const healthHouseFeaturesCastRoutes: Route[] = [
  {
    path: '',
    component: CastPageComponent
  }
];
